import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/cn';

/** Public auth routes render outside AppShell — fixed UI should span the full viewport. */
const PUBLIC_AUTH_PATH_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/set-password',
  '/mfa/verify',
  '/auth/',
] as const;

/**
 * True when the current route sits inside AppShell (sidebar + main content column).
 */
export function useAppShellMainInset(): boolean {
  const { pathname } = useLocation();
  return !PUBLIC_AUTH_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix),
  );
}

/**
 * Horizontal bounds for fixed UI anchored to AppShell `main` instead of the viewport.
 * Matches `lg:ml-[var(--sidebar-width)]` / collapsed width on the content column.
 */
export function appMainFixedHorizontalInsetClass(sidebarCollapsed: boolean): string {
  return cn(
    'left-0 lg:left-[var(--sidebar-width)]',
    sidebarCollapsed && 'lg:left-[var(--sidebar-collapsed-width)]',
  );
}
